import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "task content"
}

import { onMounted, onBeforeUnmount } from 'vue'
import { getAxiosErrorText } from '@/common/helpers'

// Components
import Error404 from '@/views/Error404'
import TaskStep from '@/components/TaskStep'
import TaskInfo from '@/components/TaskInfo'
import { ElNotification } from 'element-plus'

// i18n
import { useI18n } from 'vue-i18n'
import { useRouter, useRoute } from 'vue-router'
import { useTaskStore, useCommonStore } from '@/store'

export default /*#__PURE__*/_defineComponent({
  __name: 'Task',
  setup(__props) {

const { t } = useI18n()

// Router
const router = useRouter()
const route = useRoute()
const id = route.params.id.toString()

// Store
const taskStore = useTaskStore()
const commonStore = useCommonStore()

// Mounted
onMounted(async () => {
  commonStore.loading = true
  try {
    taskStore.task = await taskStore.getTask(id)
  } catch (e: any) {
    taskStore.error = true
    ElNotification({
      title: t('common.error'),
      message: getAxiosErrorText(e),
      type: 'error',
    })
  } finally {
    taskStore.init = true
    commonStore.loading = false
  }
})

// UnMounted
onBeforeUnmount(() => {
  taskStore.$reset()
})

return (_ctx: any,_cache: any) => {
  return (_unref(taskStore).init && _unref(taskStore).error && !_unref(taskStore).loading)
    ? (_openBlock(), _createBlock(_unref(Error404), { key: 0 }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('task.404')), 1)
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(taskStore).screen === 'main')
          ? (_openBlock(), _createBlock(_unref(TaskInfo), { key: 0 }))
          : (_openBlock(), _createBlock(_unref(TaskStep), { key: 1 }))
      ]))
}
}

})